export default __webpack_public_path__ + "static/media/right.f22650c3.svg";